import React from "react";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import "./styles/main.css";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
